const sessionKey = 'session';
const switchDashboardKey = 'switchDashboard';
const collapseKey = 'collapse';
const schedulerStatusModelsKey = 'schedulerStatusModels';
const schedulerStatusModelGroupKey = 'schedulerStatusModelGroup';
const dashboardModelsKey = 'dashboardModels';
const dashboardModelGroupKey = 'dashboardModelGroup';
const erpActiveKey = 'erpActive';
const userNotificationCounterKey = 'userNotificationCounter';

const setItem = (key: string, value: any): void => localStorage.setItem(key, JSON.stringify(value));

const getItem = (key: string): any => {
  const value = localStorage.getItem(key);

  return (value) ? JSON.parse(value) : null;
};

export const setSession = (session): void => {
  setItem(sessionKey, session);
};

export const getSession = (): any => {
  return getItem(sessionKey);
};

export const deleteSession = (): void => {
  setSession(null);
};

export const setCollapse = (collapse: boolean): void => {
  setItem(collapseKey, collapse);
};

export const getCollapse = (): boolean => {
  return getItem(collapseKey);
};

export const deleteCollapse = (): void => {
  setSession(null);
};

export const setSwitchDashboard = (switchDashboard: boolean): void => {
  setItem(switchDashboardKey, switchDashboard);
};

export const getSwitchDashboard = (): boolean => {
  return getItem(switchDashboardKey);
};

export const deleteSwitchDashboard = (): void => {
  setSession(null);
};

export const setSchedulerStatusModels = (models: any): void => {
  setItem(schedulerStatusModelsKey, models);
};

export const getSchedulerStatusModels = (): any => {
  return getItem(schedulerStatusModelsKey);
};

export const deleteSchedulerStatusModels = (): void => {
  setItem(schedulerStatusModelsKey, null);
};

export const setSchedulerStatusModelGroup = (group: any): void => {
  setItem(schedulerStatusModelGroupKey, group);
};

export const getSchedulerStatusModelGroup = (): any => {
  return getItem(schedulerStatusModelGroupKey);
};

export const deleteSchedulerStatusModelGroup = (): void => {
  setItem(schedulerStatusModelGroupKey, null);
};

export const setDashboardModels = (models: any): void => {
  setItem(dashboardModelsKey, models);
};

export const getDashboardModels = (): any => {
  return getItem(dashboardModelsKey);
};

export const deleteDashboardModels = (): void => {
  setItem(dashboardModelsKey, null);
};

export const setDashboardModelGroup = (group: any): void => {
  setItem(dashboardModelGroupKey, group);
};

export const getDashboardModelGroup = (): any => {
  return getItem(dashboardModelGroupKey);
};

export const deleteDashboardModelGroup = (): void => {
  setItem(dashboardModelGroupKey, null);
};

export const setErpActive = (erpActive): void => {
  setItem(erpActiveKey, erpActive);
};

export const getErpActive = (): any => {
  return getItem(erpActiveKey);
};

export const setUserNotificationCounter = (userNotificationCounter): void => {
  setItem(userNotificationCounterKey, userNotificationCounter);
};

export const getUserNotificationCounter = (): any => {
  return getItem(userNotificationCounterKey);
};




// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/storage.service.ts